import React from "react";
import Button from "@scripts/react/components/Button";
import { TooltipContainer } from "@scripts/react/components/Tooltip";

interface AnnotationLabelsToggleProps {
    showLabels: boolean;
    onToggle: (show: boolean) => void;
}

export const AnnotationLabelsToggle: React.FC<AnnotationLabelsToggleProps> = ({
    showLabels,
    onToggle
}) => {
    return (
        <TooltipContainer
            type="titleOnly"
            title={showLabels ? "Labels Visible" : "Labels Hidden"}
            customButton={
                <span>
                    <Button
                        onClick={() => onToggle(!showLabels)}
                        type="ghost"
                        size="xsmall"
                        className="z-40"
                        shape="square"
                    >
                        {showLabels ? (
                            <i className="fas fa-eye" />
                        ) : (
                            <i className="fas fa-eye-slash" />
                        )}
                    </Button>
                </span>
            }
        />
    );
};
